import {
  MAIN_ROUTES,
} from '@/router/components';
import { BackgroundColors } from '@/@types/types';

export default {
  path: '/data-products',
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.data-products',
    disabled: false,
  },
  component: MAIN_ROUTES.DATA_PRODUCTS,
  children: [
    {
      path: '/',
      name: 'data-products',
      meta: {
        requiresAuth: true,
        hideBreadCrumb: true,
        breadCrumb: 'app.navigation-drawer.data-products',
        background: BackgroundColors.SECONDARY,
      },
      component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
        path: 'add',
        name: 'data-products.data-product.add',
        meta: {
          requiresAuth: true,
          breadCrumb: 'data_products.breadcrumb.new',
          breadCrumbFromParamName: true,
          permissions: ['data_product.write'],
          background: BackgroundColors.SECONDARY,
        },
        props: true,
        component: () => import('@/views/FrontendNextRouteView.vue'),
    },
    {
        path: ':id',
        name: 'data-products.data-product.edit',
        meta: {
          requiresAuth: true,
          breadCrumb: 'data_products.breadcrumb.edit',
          breadCrumbFromParamName: true,
          permissions: ['data_product.write'],
          background: BackgroundColors.SECONDARY,
        },
        props: true,
        component: () => import('@/views/FrontendNextRouteView.vue'),
      },
  ],
};
